// removed by extract-text-webpack-plugin
module.exports = {"control_container":"control_container_1Loph","gap":"gap_25ZVZ","gap_grow":"gap_grow_IaBPu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/control_panel/style.scss
// module id = 523
// module chunks = 0